import React, { useContext, useEffect, useMemo, useState } from "react";
import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, TextField, Tooltip, Typography } from "@mui/material";
import { API } from "../conf";
import { Context } from "../App";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Header from "../Components/ui/Header";
import Policy from "../Components/sections/verse-form-policy";
import Step1 from "../Components/forms/verse-form-step1";
import Step2 from "../Components/forms/verse-form-step2";
import Step3 from "../Components/forms/verse-form-step3";
import Step4 from "../Components/forms/verse-form-step4";
import FinalStep from "../Components/sections/verse-form-final-step";
import success_gif from '../asset/pictures/Successfully Done.gif'
import { HelpOutlineRounded } from "@mui/icons-material";
import VerseHelper from "../Components/sections/verseHelper";

export default function VerseForm() {
    const navigate = useNavigate()
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const {updateConnect, exercice} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [eglises, setEglises] = useState([])
    const [egliseId, setEglise] = useState('')
    const [banqueComptes, setBanqueComptes] = useState([])
    const [dispoDates, setDispoDates] = useState([])
    const [currentStepIndex, setCurrentStepIndex] = useState(0)

    //animation de success
    const [result, setResult] = useState()

    const [dispoMoney, setDispoMoney] = useState([])
    const [exchange, setExchange] = useState([{originalMoney:'', originalMoneyCount:0, exchangedMoney:[{montant:'', count:0}]}])
    const [pcMensuel, setPcMensuel] = useState(0) //total petite caisse des versement antérieur du mois de la date des dons sélectionnée

    const [fedVerseType, setFedVerseType] = useState('')
    const [fedBanque, setFedBanque] = useState('')
    const [take_petite_caisse, setTakePetiteCaisse] = useState(true)
    const [dateDons, setDate] = useState('')
    const [dons, setDons] = useState([])
    const [fedRepartition, setFedRepartition] = useState({especes:[{montant:'', count:0}], cheques:[], retrait:[{montant:'', count:0}], virement:{date:moment().format('yyyy-MM-DD'),montant:0,ref:''}})
    const [petiteCaisse, setPetiteCaisse] = useState([{montant:'', count:0}])
    const [banqueEglise, setBanqueEglise] = useState({especes:[{montant:'', count:0}], cheques:[]})

    const eglise = useMemo(()=>organisation&&organisation.type==='église' ? organisation : eglises.find(el=>el._id===egliseId), [egliseId, eglises, organisation])

    useEffect(()=>{
        if(!dateDons || dateDons==='' || !!!eglise) return
        fetch(API+'/versements/petite-caisse', {method:'POST', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({$expr: {$eq: [{$month: "$dateDons"}, new Date(dateDons).getMonth()+1]}, eglise: eglise.number})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setPcMensuel(json || 0)
                }
            }
        }).catch(err=>console.log(err))
    }, [dateDons, eglise])

    useEffect(()=>{
        if(currentStepIndex===1){
            setLoad(true)
            fetch(API.concat(`/dons/${eglise.number}/no_verse/dates?exercice=${exercice}`), {method:'GET', headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                
            }}).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setDispoDates(json)
                    } 
                    setLoad(false)
                }
            })
        }
        else if (currentStepIndex===2) {
            setLoad(true)
            fetch(API.concat(`/dons/by/${JSON.stringify({eglise: eglise.number, is_preverse: false, date:dateDons})}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        if(!(json.length===dons.length&&json.every(d=>dons.some(don=>don._id===d._id)))){
                            setDons(json);
                            setDispoMoney([...new Set(json.map(don=>don.repartition.especes.map(es=>es.montant)).flat())]
                                .map(money=>({montant:money, count: json.reduce((tt,don)=>tt+(don.repartition.especes.find(es=>es.montant===money)?.count??0),0)}))
                                .filter(dm=>dm.count>0))
                            setFedBanque('')
                            setFedRepartition({especes:[{montant:'', count:0}], cheques:[], retrait:[{montant:'', count:0}], virement:{date:moment().format('yyyy-MM-DD'),montant:0,ref:''}})
                            setPetiteCaisse([{montant:'', count:0}])
                            setBanqueEglise({especes:[{montant:'', count:0}], cheques:[]})
                            setLoad(false)
                        } else setLoad(false)
                    }else setLoad(false)
                }
            })
        }
    }, [currentStepIndex])

    const fed_part = useMemo(()=>dons?.reduce((tt,current)=>tt+current.dime+Math.round((current.offrande_globale*0.4+Number.EPSILON)*100)/100+current.offrande_spe_feam.reduce((to,off)=>to+off.montant,0),0), [dons])
    const local_part = useMemo(()=>dons?.reduce((tt,current)=>tt+current.offrande_globale-Math.round((current.offrande_globale*0.4+Number.EPSILON)*100)/100+current.offrande_spe_eglise.reduce((to,off)=>to+off.montant,0),0), [dons])
    const totalFedVerse = useMemo(()=>Math.round(((fedRepartition.especes.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+fedRepartition.cheques.reduce((tt,ch)=>tt+ch.montant,0)+fedRepartition.retrait.reduce((tt,es)=>tt+Number(es.montant)*es.count,0))+Number.EPSILON)*100)/100,[fedRepartition])
    const totalPetiteCaisse = useMemo(()=>petiteCaisse.reduce((tt,es)=>tt+Number(es.montant)*es.count,0),[petiteCaisse])
    const ttPcMensuel = useMemo(()=> pcMensuel + totalPetiteCaisse, [pcMensuel, totalPetiteCaisse])
    const totalLocalRepartition = useMemo(()=>petiteCaisse.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+banqueEglise.especes.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+banqueEglise.cheques.reduce((tt,ch)=>tt+ch.montant,0),[petiteCaisse, banqueEglise])
    const restToRepart = useMemo(()=>Math.round(((dons.reduce((tt,don)=>tt+don.repartition.especes.reduce((t,es)=>t+es.montant*es.count,0)+don.repartition.cheques.reduce((t,ch)=>t+ch.montant,0),0)
        -[...banqueEglise.especes, ...petiteCaisse].reduce((tt,es)=>tt+es.montant*es.count,0)-banqueEglise.cheques.reduce((tt,ch)=>tt+ch.montant,0))+Number.EPSILON)*100)/100,[dons,petiteCaisse,banqueEglise])

    const steps = useMemo(() => [
        { component: <Policy />, disabled:!eglise, action: () => setCurrentStepIndex(old=>old+1) },
        //choix de la date des dons
        { component: <Step1 {...{fedVerseType, setFedVerseType, take_petite_caisse, setTakePetiteCaisse, eglise,dispoDates,dateDons,setDate}}/>, 
            disabled:fedVerseType===""||dateDons==='', 
            action: () => setCurrentStepIndex(old=>old+1) 
        },
        //recapitulatif des recettes
        { component: <Step2 {...{dons, fed_part, local_part}}/>, 
            disabled:fed_part+local_part<=0, 
            action: async() => {
                if(!take_petite_caisse)setPetiteCaisse([{montant:'', count:0}]); 
                if(eglise.have_banque&&fedVerseType.includes('siege')){setAllInLocaleBanqueAndRecap()} 
                else setCurrentStepIndex(old=>old+(take_petite_caisse?1:2))
            } 
        },
        //alimentation petite caisse
        { component: <Step3 {...{eglise, dons, ttPcMensuel, dispoMoney, setDispoMoney, exchange, setExchange:e=>setExchange(e), cancelExchange, take_petite_caisse, local_part, petiteCaisse, setPetiteCaisse,banqueEglise, setBanqueEglise}}/>, 
            disabled:(ttPcMensuel>eglise?.limite_petite_caisse), 
            action: () => eglise?.have_banque&&fedVerseType!=='siege'? setAllInLocaleBanqueAndRecap() : setCurrentStepIndex(old=>old+1) 
        },
        //versement FEAM
        { component: <Step4 {...{eglise, dons, dispoMoney, banqueComptes, fedVerseType,restToRepart, fedBanque, setFedBanque, setFedRepartition, fedRepartition, fed_part, petiteCaisse, banqueEglise}}/>, 
            disabled:(!eglise?.have_banque)&&totalFedVerse<restToRepart, 
            action: () => eglise?.have_banque&&fedVerseType==='siege'? setAllInLocaleBanqueAndRecap() : setCurrentStepIndex(old=>old+1) 
        },
        //recapitulatif et confirmation
        { component: <FinalStep {...{eglise,fedRepartition,fedVerseType,fed_part,local_part,totalFedVerse,totalLocalRepartition,petiteCaisse,banqueEglise}} />, action: () => manageDialog(true, 'confirm') },
    ], [eglise, dispoMoney, exchange, setExchange, dispoDates, ttPcMensuel, fedVerseType, take_petite_caisse, dateDons, dons, banqueComptes, fed_part, local_part,fedBanque,fedRepartition, totalFedVerse, restToRepart, petiteCaisse, banqueEglise, totalLocalRepartition]);
    const currentStep = useMemo(() => steps[currentStepIndex], [currentStepIndex, steps]);

    function handleSubmit() {
        setLoad(true); setOpen(false)
        const versement = {
            fedVerseType,
            dateDons,
            feam_banque:fedBanque,
            dons:dons.map(d=>d.num),
            fedRepartition:{...fedRepartition,especes:fedRepartition.especes.filter(es=>es.montant>0&&es.count>0),retrait:fedRepartition.retrait.filter(es=>es.montant>0&&es.count>0)},
            petiteCaisse:petiteCaisse.filter(es=>es.montant>0&&es.count>0),
            banqueEglise:{...banqueEglise, especes:banqueEglise.especes.filter(es=>es.montant>0&&es.count>0)}, 
            eglise:eglise.number,
            exercice
        }
        fetch(API.concat(`/versements`), {method:'POST', headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },body: JSON.stringify(versement)
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setResult(<img src={success_gif} alt="succès" loading="eager" width={500} height={500}/>)
                    setTimeout(() => navigate('/'), 2500);
                } else {
                    setLoad(false)
                }
            }
        })
    }

    function setAllInLocaleBanqueAndRecap(){
        setLoad(true)
        const dispoCheques = dons.map(don=>don.repartition.cheques).flat()
        const MoneyRest = dispoMoney.map(money=>({
            montant: money.montant, 
            count: money.count
                -(take_petite_caisse? (petiteCaisse.filter(es=>es.montant===money.montant).reduce((tt,es)=>tt+es.count,0)??0) : 0)
                -(fedVerseType==='siege'? (fedRepartition.especes.filter(es=>es.montant===money.montant).reduce((tt,es)=>tt+es.count,0)??0) : 0)
        })).filter(m=>m.count>0)
        setBanqueEglise({especes:MoneyRest, cheques:fedVerseType==='siege'? dispoCheques.filter(dc=>!fedRepartition.cheques.some(ch=>JSON.stringify(ch)===JSON.stringify(dc))) : dispoCheques})
        if(fedVerseType!=='siege') setFedRepartition(old=>({...old, especes:[{montant:'', count:0}], cheques:[]}))
        setLoad(false);
        setCurrentStepIndex(old=> take_petite_caisse&&old<3 ? old+1 :5)
    }

    function cancelExchange(){
        setExchange([{originalMoney:'', originalMoneyCount:0, exchangedMoney:[{montant:'', count:0}] }])
        setDispoMoney([...new Set(dons.map(don=>don.repartition.especes.map(es=>es.montant)).flat())]
            .map(money=>({montant:money, count: dons.reduce((tt,don)=>tt+(don.repartition.especes.find(es=>es.montant===money)?.count??0),0)}))
            .filter(dm=>dm.count>0))
    }

    function manageDialog(open, action='') {
        setOpen(open)
        setAction(action)
    }
    
    useEffect(()=>{
        if (organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    function setEgliseId(eglise_id) {
        setEglise(old=>{
            if (old!==eglise_id) {
                setFedVerseType('')
                setTakePetiteCaisse(true)
                setDate('')
                setDons([])
                setDispoMoney([])
                setExchange([{originalMoney:'', originalMoneyCount:0, exchangedMoney:[{montant:'', count:0}]}])
                setFedRepartition({especes:[{montant:'', count:0}], cheques:[], retrait:[{montant:'', count:0}], virement:{date:'',montant:0,ref:''}})
                setPetiteCaisse([{montant:'', count:0}])
                setBanqueEglise({especes:[{montant:'', count:0}], cheques:[]})
            } 
            return eglise_id
        })
    }

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
        fetch(API.concat(`/comptes/federation/banque?exercice=${exercice}`), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setBanqueComptes(json)
                    setLoad(false)
                }
            }
        })
    },[])

    return(
        <Box display='flex' flex={1} flexDirection='column' style={{height:'100vh'}}>
            <Header/>
            <Box display='flex' flexDirection='row' marginTop={3} marginBottom={organisation&&organisation.type==='fédération'?0:3}>
                <Typography variant="h4" align="center" sx={{flex:1}}>Édition bordereau de versement</Typography>
                {eglise?.have_banque&&<Tooltip title="Aide et procédures">
                    <IconButton onClick={()=>manageDialog(true, 'help')} sx={{mr:3}}><HelpOutlineRounded /></IconButton>
                </Tooltip>}
            </Box>
            {organisation&&organisation.type==='fédération'&&<>{currentStepIndex===0?<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(e.target.value)}>
                {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>:<Typography variant="h6" align="right" marginRight={5} marginBottom={3}>église {eglise.nom} - {eglise.commune.toUpperCase()}</Typography>}</>}
            <Box display='flex' flex={1} flexDirection='column' sx={{alignSelf:'center', width:'80%', border:'black 2px solid', padding:2, marginBottom:'5%', overflow:'auto'}}>
                <Box sx={{flexGrow:1, marginBottom:2}}>
                    {currentStep.component}
                </Box>

                <Box display='flex' justifyContent='space-between' alignItems='center'>
                    <Box>{currentStepIndex>0&&<Button variant="contained" 
                    onClick={()=>setCurrentStepIndex(old=> old-((old===4&&!take_petite_caisse)? 2 : old===5&&eglise?.have_banque&&fedVerseType!=='siege'? !take_petite_caisse? 3 : 2 : 1))}>
                        précédent
                    </Button>}</Box>
                    <Button variant="contained" disabled={currentStep.disabled??false} onClick={currentStep.action}>{currentStepIndex === steps.length - 1 ? 'Terminer' : 'Continuer'}</Button>
                </Box>
            </Box>
            <Dialog open={open} onClose={()=>setOpen(false)} fullWidth maxWidth={action==='confirm' ?'sm':'md'}>
                {action==='confirm'&&<><DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography>Vous confirmez l'enregistrement et la transmission au siège fédéral des informations renseignées précédemment?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setOpen(false)}>Annuler</Button>
                    <Button onClick={handleSubmit}>Confirmer</Button>
                </DialogActions></>}
                {action==='help'&&<VerseHelper/>}
            </Dialog>
            <Backdrop open={load}>{result??<CircularProgress/>}</Backdrop>
        </Box>
    )
}